import { createReducer, on, Action } from "@ngrx/store";
import * as CacheActions from "../actions/cache.actions";
import { ReportCache } from "core-lib";

export interface CacheState {
    loading: boolean,
    loaded: boolean,
    entity: ReportCache
}

export const initialSate: CacheState = {
    loaded: false,
    loading: false,
    entity: null
}

const cacheReducer = createReducer(
    initialSate,
    on(CacheActions.loadCache, state => ({ ...state, loading: true, loaded: false })),
    on(CacheActions.loadCacheFail, state => ({ ...state, loading: false, loaded: false })),
    on(CacheActions.loadCacheSuccess, (state, props) => ({ ...state, loaded: true, loading: false, entity: props.cache }))
);

export function reducer(state: CacheState = initialSate, action: Action): CacheState {
    return cacheReducer(state, action);
}

